import { render, staticRenderFns } from "./pagos-contable.vue?vue&type=template&id=abf044a4"
import script from "./pagos-contable.vue?vue&type=script&lang=js"
export * from "./pagos-contable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports